import React from 'react';

const Spinner = () => {
	return (
		<div className="loadingBackground">
			<div className="loadingSpinnerContainer">
				<div className="loadingSpinner"></div>
			</div>
		</div>
	);
};

export default Spinner;
